import React from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import Stepper from '../../organisms/Stepper';
import TableCardGrid from '../../organisms/TableCardGrid';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import { SETTINGS_STEPS } from '../../../data/settingsSteps';

export default function WorkflowStep({
  onNext: _onNext,
  stepMeta,
  stepperProps,
  selectedTableCard,
}) {
  const { state, updateWorkflow } = useSettingsWizard();
  const { workflow } = state;
  // const SelectedTableCard=null;
  const resolvedSelectedTableCard = selectedTableCard ?? workflow.selectedTableCard ?? null;

  return (
    <>
      {/* Main wizard stepper */}
      <Stepper {...stepperProps} steps={SETTINGS_STEPS} />

      <SettingsCard
        title={stepMeta.title}
        description={stepMeta.description}
        showNext={false}
      >
     

          {/* Workflow Table Grid */}
          <div className="ca-workflow__main">
            <TableCardGrid
              initialTables={workflow.steps}
              selectedTableId={resolvedSelectedTableCard?.id}
              onSelect={(table) => updateWorkflow({ selectedTableCard: table })}
              onChange={(steps) =>
                updateWorkflow({
                  steps,
                  selectedTableCard: resolvedSelectedTableCard
                    ? steps.find((step) => step.id === resolvedSelectedTableCard.id) ?? null
                    : null,
                })
              }
            />
          </div>
        {/* </div> */}
      </SettingsCard>
    </>
  );
}